import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  if(value > 100 && value < 60) {
    return { 
      title: 'ชีพจรผิดปกติ',
      color: 'red',
      caption: 'ชีพจรผิดปกติ',
      suggest: 'ควรไปพบแพทย์'
    };
  } else {
    return { 
      title: 'ชีพจรปกติ',
      color: 'red',
      caption: 'ชีพจรปกติ',
      suggest: ''
    };
  }

}